import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleYesterdayActualsHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type YesterdayActualsCardProps = {
  titleHref: string
  actuals: HuddleDashboard['yesterdayActualsApi']
  className?: string
}

export function YesterdayActualsCard({
  titleHref,
  actuals,
  className = 'dashboard-huddle-forecast-card dashboard-huddle-full-row dashboard-huddle-yesterday-actuals-row',
}: YesterdayActualsCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = actuals
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleYesterdayActualsHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Yesterday's actuals"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
